import {PortalModule} from '@angular/cdk/portal';
import {CommonModule} from '@angular/common';
import {InjectionToken, ModuleWithProviders, NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatTreeModule} from '@angular/material/tree';
import {RouterModule} from '@angular/router';
import {
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbInputModule,
  NbSelectModule,
  NbTooltipModule
} from '@nebular/theme';
import {TuiAutoFocus} from '@taiga-ui/cdk';
import {TuiIcon} from '@taiga-ui/core';
import {ConfirmDialogComponent} from './components/confirm-dialog/confirm-dialog.component';
import {DadataComponent} from './components/dadata/dadata.component';
import {ErrorDialogComponent} from './components/error-dialog/error-dialog.component';
import {OneDigitDirective} from './directives/OneDigitDirective';
import {PhoneMaskDirective} from './directives/PhoneMaskDirective';
import {RussianPhoneMaskDirective} from './directives/RussianPhoneMaskDirective';
import {Environment} from './interfaces/Environment';
import {MarkupBuilder} from './interfaces/MarkupBuilder';
import {AutoLabelPipe} from './pipes/auto-label.pipe';
import {FormatTimePipe} from './pipes/format-time';
import {SafeHtmlPipe} from './pipes/safe-html.pipe';
import {TrueFalseToYesNoPipe} from './pipes/true-false-to-yes-no';
import {CompoApiService} from './services/compo-api.service';
import {CountDownService} from './services/count-down.service';
import {DecreaseByPercentageStrategy} from './services/strategies/decrease-by-percentage.strategy';
import {DecreaseByValueStrategy} from './services/strategies/decrease-by-value.strategy';
import {IncreaseByPercentageStrategy} from './services/strategies/increase-by-percentage.strategy';
import {IncreaseByValueStrategy} from './services/strategies/increase-by-value.strategy';
import {RestorePriceStrategy} from './services/strategies/restore-price.strategy';

export const MarkupBuilderToken: InjectionToken<MarkupBuilder[]> = new InjectionToken<MarkupBuilder[]>('MarkupBuilder');

/**
 * Creating shared modules allows you to organize and streamline your code.
 * You can put commonly used directives, pipes, and components
 * into one module and then import just that module wherever you need it in other parts of your app.
 * {@link https://angular.io/guide/sharing-ngmodules}
 */
@NgModule({
  declarations: [
    RussianPhoneMaskDirective, PhoneMaskDirective, OneDigitDirective, DadataComponent,
    FormatTimePipe, AutoLabelPipe, ConfirmDialogComponent, ErrorDialogComponent,
    TrueFalseToYesNoPipe, SafeHtmlPipe],
  exports: [
    RussianPhoneMaskDirective, PhoneMaskDirective, OneDigitDirective,
    FormatTimePipe, AutoLabelPipe, TrueFalseToYesNoPipe,
    DadataComponent, SafeHtmlPipe, ConfirmDialogComponent, ErrorDialogComponent],
  imports: [PortalModule, NbSelectModule, NbInputModule, CommonModule, NbAutocompleteModule, MatTreeModule,
    NbIconModule, NbTooltipModule, RouterModule, MatButtonModule, NbCardModule, NbButtonModule, TuiIcon, TuiAutoFocus],
  providers: [CompoApiService, CountDownService,
    {provide: MarkupBuilderToken, useClass: IncreaseByPercentageStrategy, multi: true},
    {provide: MarkupBuilderToken, useClass: DecreaseByPercentageStrategy, multi: true},
    {provide: MarkupBuilderToken, useClass: IncreaseByValueStrategy, multi: true},
    {provide: MarkupBuilderToken, useClass: DecreaseByValueStrategy, multi: true},
    {provide: MarkupBuilderToken, useClass: RestorePriceStrategy, multi: true}
  ]
})
export class SharedModule {

  public static forRoot(environment: Environment): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        {provide: environment, useValue: environment},
        {provide: 'environment', useValue: environment},
        {provide: Environment, useValue: environment}
      ]
    };
  }

}
